import { RefObject, useCallback, useEffect, useRef } from "react";

const useClickOutside = <T extends HTMLElement>(
	ref: RefObject<T>,
	callback: () => void,
	circuitBreaker = false,
	ignoreSelector?: string,
) => {
	const callbackRef = useRef<() => void>();

	useEffect(() => {
		callbackRef.current = callback;
	}, [callback]);

	const handleClickOutside = useCallback(
		(event: MouseEvent) => {
			const target = event.target as Element;

			if (target.closest("[data-stop-click-outside-propagation]")) {
				return;
			}

			if (ignoreSelector && target.closest(ignoreSelector)) {
				return;
			}

			if (!circuitBreaker && ref.current && !ref.current.contains(event.target as Node)) {
				callbackRef.current?.();
			}
		},
		[circuitBreaker, ref, ignoreSelector],
	);

	useEffect(() => {
		document.addEventListener("mousedown", handleClickOutside);

		return () => {
			document.removeEventListener("mousedown", handleClickOutside);
		};
	}, [handleClickOutside]);
};

export default useClickOutside;
